import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { Dispatch, SetStateAction, useEffect, useState } from "react";

interface PhoneElementI {
  phoneValue: string;
  setPhoneValue: Dispatch<SetStateAction<string>>;
  country?: string;
}

const PhoneElement = ({
  phoneValue,
  setPhoneValue,
  country,
}: PhoneElementI) => {
  const [detectedCountry, setDetectedCountry] = useState<string | null>(null);

  // Synchronize the dropdown width with the input width
  useEffect(() => {
    const phoneInputEl = document.querySelector(".form-control") as HTMLElement;

    if (!phoneInputEl) return;

    const updateDropdownWidth = () => {
      const phoneDropdownListEl = document.querySelector(
        ".react-tel-input .country-list"
      ) as HTMLElement;
      const dropdownIsOpen = phoneInputEl.classList.contains("open");

      if (phoneDropdownListEl && dropdownIsOpen) {
        phoneDropdownListEl.style.width = `${phoneInputEl.clientWidth}px`;
      }
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "class"
        ) {
          updateDropdownWidth();
        }
      });
    });

    observer.observe(phoneInputEl, {
      attributes: true,
      attributeFilter: ["class"],
    });

    updateDropdownWidth();

    return () => {
      observer.disconnect();
    };
  }, []);

  // Determine the country by IP if country is not provided
  useEffect(() => {
    const detectCountryByIP = async () => {
      if (!country) {
        try {
          const response = await fetch("https://ipapi.co/json/");
          const data = await response.json();
          if (data && data.country) {
            // Convert the country code to lowercase
            setDetectedCountry(data.country.toLowerCase());
          }
        } catch (error) {
          console.error(error);
          // Use default value in case of error
          setDetectedCountry("us");
        }
      }
    };

    detectCountryByIP();
  }, [country]);

  // Use the provided country or the one determined by IP
  const currentCountry = phoneValue ? "" : country || detectedCountry || "us";

  return (
    <PhoneInput
      country={currentCountry}
      value={phoneValue}
      onChange={(phone) => {
        setPhoneValue(phone);
      }}
    />
  );
};

export default PhoneElement;
